
var window = require("../../support/window.js")
var config = require("./commons/config.js")
var helper = require("./commons/helper.js")
var extend = require("extend")


// 导入默认配置
config.defaultConfigs.urls["product"] = {
    productInfo : 'product/productInfo.json'
};


var productInfo = function(parmars, reload) {
    var defaultParmar = {
        productId : undefined
    };
    return helper.reqHelper(
        "product", "productInfo",
        extend({}, defaultParmar, parmars), reload,
        function(obj) {
            return obj && obj.productInfo && obj.productInfo.id && obj.productInfo.id.length > 0
        }).then(function(json) {
            return json.productInfo;
        });
};



module.exports = {
    productInfo : productInfo
}


//////////////////
// WEBPACK FOOTER
// ./src/main/javascript/func/fdapi/product.js
// module id = 6
// module chunks = 0